exports.BLUE = "#2F549B";
exports.BLUE_DARK = "#2955a2";
exports.DARK_BLUE = "#37386E";
exports.DARK_GRAY = "#2C2C2E";
exports.DARK_PURPLE = "#29295C";
exports.GOLD = "#FEEFB3";
exports.GOLD = "#FEEFB3";
exports.GRADIENT_BG_BLUE = "linear-gradient(270deg, rgba(43,86,159,0.85) 0%, rgba(43,86,159,0.36) 100%)";
exports.GRAY = "#64666c";
exports.GRAY = "#909090";
exports.GRAY_PLACEHOLDER = "#979797";
exports.GREEN = "#3FCA89";
exports.GREEN = "#80DDCD";
exports.LIGHT_FADE_GRAY = "rgba(43,86,159,0.29);";
exports.LIGHT_FADE_GREEN = "rgba(169, 210, 203, 0.21)";
exports.LIGHT_GRAY = "#AFAFAF";
exports.LIGHT_GREEN = "#80DDCD";
exports.NEW_BLUE = "#2B56A3";
exports.PINK = "#CA367E";
exports.PRIMARY_BLUE = "#2B569F";
exports.RED = "#F85D5D";
exports.SECONDARY_BLUE = "#426DB7";
exports.SEC_FONT_GREY = "#9b9b9b";
exports.TEXT1 = "#202020";
exports.TOP_GRADIENT_BG_BLUE = "linear-gradient(180deg, rgba(43,86,159,0.85) 0%, rgba(43,86,159,0.36) 100%)";
exports.WARNING_RED = "#f75d70";
exports.WHITE = "#FFFFFF";
exports.WHITE_GRAY = "#F5F5F5";

exports.WARNING_700 = "#B54708";

exports.SUCCESS_700 = "#027A48";

exports.PRIMARY_700 = "#175CD3";

exports.ERROR_700 = "#B42318";
